import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './index.module.scss';
import staticText from 'static/text_display.json';
import { SaveIcon } from 'Icons';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import ArrowBackSharpIcon from '@material-ui/icons/ArrowBackSharp';
import IconWithText from 'components/IconWithText/iconWithText';

const useStyles = makeStyles(theme => ({
  headerColor: {
    background: theme.palette.primary.main,
    color: `${theme.palette.secondary.light} !important`,
  },
}));

const Header = ({
  className,
  icon,
  title,
  onClick,
  iconTitle = staticText.general.cancel,
  onSaveClick,
  isSaveRequired,
}) => {
  const classes = useStyles();

  const { t } = useTranslation();
  return (
    <section className={cn(className, styles.header, classes.headerColor)}>
      <div className={cn(styles.iconStyling)}>
        {icon && (
          <IconWithText
            component={ArrowBackSharpIcon}
            title={iconTitle}
            onClick={onClick}
            theme={'light'}
          />
        )}
        <h2>{t(title)}</h2>
      </div>
      {isSaveRequired && (
        <IconWithText
          component={SaveIcon}
          title={t(staticText.general.save)}
          onClick={onSaveClick}
          theme={'light'}
        />
      )}
      {/* <IconButton onClick={onSaveClick} title={t(general.save)}>
        <SaveIcon fontSize="large" />
      </IconButton> */}
      {/* )} */}
    </section>
  );
};

Header.propTypes = {
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  close: PropTypes.bool,
  icon: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  onClick: PropTypes.func,
  iconTitle: PropTypes.string,
  onSaveClick: PropTypes.func,
  saveIcon: PropTypes.string,
  isSaveRequired: PropTypes.bool,
};

export default Header;
